// extracted by mini-css-extract-plugin
export default {"list-item":"Todo_list-item__644dP","floatRight":"Todo_floatRight__i76Jc"};